const getRetirementYear = (
  expenseTimelineResult: Forme.ExpenseTimeline | undefined
) => {
  return Math.min(
    expenseTimelineResult?.client?.retirementYear || 3000,
    expenseTimelineResult?.coClient?.retirementYear || 3000
  );
};

const getEndOfPlanYear = (
  expenseTimelineResult: Forme.ExpenseTimeline | undefined
) => {
  return Math.max(
    expenseTimelineResult?.client?.planningYear || 0,
    expenseTimelineResult?.coClient?.planningYear || 0
  );
};

export { getRetirementYear, getEndOfPlanYear };
